import React from "react";
import PropTypes from "prop-types";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { matchSorter } from "match-sorter";
import { Autocomplete, TextField } from "@mui/material";

function ProfileAutocomplete(props) {
  const { label, options, selectedValue, selectedSetter, providedOnChange } = props;

  return (
    <Autocomplete
      multiple
      size="small"
      disableCloseOnSelect
      value={selectedValue}
      limitTags={5}
      id="tags-standard"
      options={options}
      className="ProfileAutocomplete border-profile-gray"
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{ ...params.InputProps }}
        />
      )}
      sx={{ width: 250 }}
      renderOption={(props, option, { inputValue }) => {
        const matches = match(option, inputValue, { insideWords: true });
        const parts = parse(option, matches);

        return (
          <li {...props}>
            <div>
              {parts.map((part, index) => (
                <span
                  key={index}
                  style={{
                    fontWeight: part.highlight ? 700 : 400,
                    fontSize: 16,
                  }}
                >
                  {part.text}
                </span>
              ))}
            </div>
          </li>
        );
      }}
      filterOptions={(options, { inputValue }) =>
        matchSorter(options, inputValue)
      }
      onChange={(event, value) => {
        selectedSetter(value);
        providedOnChange();
      }}
    />
  );
}

ProfileAutocomplete.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  selectedValue: PropTypes.arrayOf(PropTypes.string),
  selectedSetter: PropTypes.func,
  providedOnChange: PropTypes.func,
};

ProfileAutocomplete.defaultProps = {
  label: "",
  options: [],
  selectedValue: [],
  selectedSetter: () => { },
  providedOnChange: () => { },
};

export default ProfileAutocomplete;
